export default __webpack_public_path__ + "static/saas-banner-0be7f32fb617ee19ecacefda1b3ccf30.png";